/**
 * PageHeader Component
 *
 * Page-specific header with title, subtitle, and actions.
 * Used below the global AppHeader navigation.
 * Based on UX_DESIGN.md Page Structure Patterns.
 */

import { ReactNode } from "react";

interface PageHeaderProps {
  /**
   * Page title (H1)
   */
  title: string;
  /**
   * Optional subtitle/description
   */
  subtitle?: string;
  /**
   * Optional action buttons (e.g., "Create Quiz" button)
   */
  actions?: ReactNode;
  /**
   * Optional custom styling
   */
  className?: string;
}

export function PageHeader({ title, subtitle, actions, className = "" }: PageHeaderProps) {
  return (
    <div className={`border-b bg-card ${className}`}>
      <div className="container mx-auto px-4 py-6 md:py-8 max-w-7xl">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div className="flex-1 min-w-0">
            <h1 className="text-3xl md:text-4xl font-bold mb-2">{title}</h1>
            {subtitle && (
              <p className="text-muted-foreground text-base md:text-lg">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 flex-shrink-0">
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
